module.exports = {
    dynamic: {
        CommodityCodeIsInvalid: 'Goederencode is onjuist',
        CommodityCodeOrQueryIsRequired: 'Goederencode of zoektekst is verplicht',
        QueryIsTooShort: 'Zoektekst is te kort',
        QueryIsRequired: 'Zoektekst is verplicht',
    }
};